import styled from '@emotion/styled';

export const StyledCalendarWrapper = styled.div`
    display: flex;
    background-color: ${(props) => props.theme.shades['white-90']};
    align-items: center;
    position: relative;
`;

export const StyledInputWrapper = styled.div`
    display: flex;
    flex: 1;
`;

export const InputSeparator = styled.span`
    display: flex;
    height: 30px;
    border-right: 1px solid ${(props) => props.theme.colors.separator};
`;

export const Input = styled.input`
    font-family: NotoSans, Helvetica, sans-serif;
    padding: 0 0 0 32px;
    height: 50px;
    font-size: ${(props) => props.theme.fontSize.regularS};
    background-color: transparent;
    border: 0;
    width: 100%;
    color: ${(props) => props.theme.shades.blackGrey};
    border-radius: 0;

    /* Move placeholder on Safari to the middle of the field */
    &::-webkit-input-placeholder {
        line-height: 1.5;
    }
`;
